import { ActiveForms } from '@core/interfaces/form.interface';
import { IMedia } from '@core/interfaces/media-interfaces';

// maybe there's a better place for this interface to be defined
export interface IPageLoader {
	show: boolean;
	counter: number;
}

export interface State {
	activeForms: ActiveForms;
	compactNavMenu: boolean;
	currentUiEvent: { eventName: string; data: any };
	error: string;
	language: string;
	media: IMedia;
	pageLoader: IPageLoader;
}

export const initialState: State = {
	activeForms: {
		businessPremises: null,
		ers: null,
		organizations: null,
		users: null
	},
	compactNavMenu: false,
	currentUiEvent: { eventName: '', data: null },
	error: null,
	language: 'en-gb',
	media: null,
	pageLoader: { show: false, counter: 0 }
};
